import { createApi } from "@reduxjs/toolkit/query/react";
import {
  baseQueryWithArgs,
  getQueryStringWithCreator,
} from "../../../utils/reduxHelper";

export const sourcingHomeReduxAPI = createApi({
  reducerPath: "sourcingHomeReduxAPI",
  baseQuery: baseQueryWithArgs,
  tagTypes: [
    "categories",
    "sourceByPriceCollections",
    "recommendedCollections",
    "subcategories",
    "brandsMain",
    "hottestDeals",
    "homeSearchBrands",
    "homeSearchProducts",
    "brandSubcategories",
    "activeOrders",
    "barterCollection",
  ],

  endpoints: (builder) => ({
    //GET Queries
    getCategories: builder.query({
      query: () => getQueryStringWithCreator(`s/getCategories`),
      providesTags: ["categories"],
    }),
    getCollectionsByPrice: builder.query({
      query: () => getQueryStringWithCreator(`s/getCollectionsByPrice`),
      providesTags: ["sourceByPriceCollections"],
    }),
    getRecommendedCollections: builder.query({
      query: () => getQueryStringWithCreator(`s/getRecommendedCollections`),
      providesTags: ["recommendedCollections"],
    }),
    getSubcategoriesFromCategory: builder.query({
      query: (categoryId) =>
        getQueryStringWithCreator(
          `s/getSubcategoriesFromCategory?categoryId=${categoryId}`
        ),
      providesTags: ["subcategories"],
      keepUnusedDataFor: 60,
    }),
    getSubcategoriesForBrand: builder.query({
      query: ({ brandId, isBrandSourcing = false }) =>
        getQueryStringWithCreator(
          `s/getSubcategoriesForBrand?brandId=${brandId}&isBrandSourcing=${isBrandSourcing}`
        ),
      providesTags: ["brandSubcategories"],
      keepUnusedDataFor: 60,
    }),
    getBrandsMainForHome: builder.query({
      query: () => getQueryStringWithCreator(`s/getBrandsMainForHome`),
      providesTags: ["brandsMain"],
    }),
    getBrandsAndCategoriesForHome: builder.query({
      query: () => getQueryStringWithCreator(`s/getBrandsAndCategoriesForHome`),
      providesTags: ["brandsMain", "categories"],
    }),
    getBarterCollection: builder.query({
      query: () => getQueryStringWithCreator(`s/getBarterCollections`),
      providesTags: ["brandsMain"],
    }),
    getBrandsEndlessForHome: builder.query({
      query: ({ page }) => {
        return getQueryStringWithCreator(
          `s/getBrandsEndlessForHome?page=${page}`
        );
      },
      providesTags: ["homeSearchProducts"],
    }),
    getBrandsAndSubcategoriesForHome: builder.query({
      query: () => {
        return getQueryStringWithCreator(`s/getBrandsAndSubcategoriesForHome`);
      },
      providesTags: ["brandsWithSubcategories"],
    }),
    getHottestDealsForHome: builder.query({
      query: () => getQueryStringWithCreator(`s/getHottestDealsForHome`),
      providesTags: ["hottestDeals"],
    }),
    getHomeSearchBrands: builder.query({
      query: ({ searchText, page }) => {
        const search = encodeURIComponent(searchText);
        return getQueryStringWithCreator(
          `s/getHomeSearchBrands?search=${search}`
        );
      },
      providesTags: ["homeSearchBrands"],
    }),
    getHomeSearchProducts: builder.query({
      query: ({ searchText, page }) => {
        const search = encodeURIComponent(searchText);
        return getQueryStringWithCreator(
          `s/getHomeSearchProducts?search=${search}&page=${page}`
        );
      },
      providesTags: ["homeSearchProducts"],
    }),
    getActiveOrders: builder.query({
      query: () => {
        return getQueryStringWithCreator(`s/getActiveOrders`);
      },
      providesTags: ["activeOrders"],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useLazyGetCategoriesQuery,
  useLazyGetCollectionsByPriceQuery,
  useLazyGetSubcategoriesFromCategoryQuery,
  useLazyGetSubcategoriesForBrandQuery,
  useLazyGetRecommendedCollectionsQuery,
  useLazyGetBrandsMainForHomeQuery,
  useLazyGetBrandsAndCategoriesForHomeQuery,
  useLazyGetBrandsEndlessForHomeQuery,
  useLazyGetBrandsAndSubcategoriesForHomeQuery,
  useLazyGetHottestDealsForHomeQuery,
  useLazyGetHomeSearchBrandsQuery,
  useLazyGetHomeSearchProductsQuery,
  useLazyGetActiveOrdersQuery,
  useGetSubcategoriesForBrandQuery,
  useGetSubcategoriesFromCategoryQuery,
  useGetBarterCollectionQuery,
  useGetRecommendedCollectionsQuery,
} = sourcingHomeReduxAPI;
